import React from 'react'
import { observer } from 'mobx-react'
import InventoryItemForm from '../../components/InventoryItemForm'
import CreateWorkspaceInventoryItemViewModel from './CreateWorkspaceInventoryItemViewModel'
import InventoryItemFormWorkspaceDropdown from '../../components/InventoryItemFormWorkpaceDropdown'

interface Props {
  vm: CreateWorkspaceInventoryItemViewModel
}

function CreateWorkspaceInventoryItemDialog({ vm }: Props) {
  return (
    <InventoryItemForm
      vm={vm}
      title="Add workspace specific service item"
      submitText="Add new"
    >
      <InventoryItemFormWorkspaceDropdown
        vm={vm}
        workspaceSelectorVM={vm.workspaceSelectorVM}
      />
    </InventoryItemForm>
  )
}

export default observer(CreateWorkspaceInventoryItemDialog)
